/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

// Séparateurs rencontrés dans un prénom : l'espace et le tiret des prénoms
// composés ("Jean-Pierre", "Marie Claire"), l'apostrophe (droite ou typo-
// graphique) et la virgule qui sert à joindre les prénoms complémentaires
// ("Jean, Pierre, Paul", cf. `formatPrenoms`).
const SEPARATEURS_PRENOM = /([\s,\-'’]+)/;

// Les champs de prénom émis par EtatCivil / ParentForm : `prenom`,
// `prenomsComplementaires`, `quatriemePrenom`... ainsi que le prénom du
// signataire (`signatairePrenom`). Le nom reçu peut être un chemin complet
// (`conventionDeclaration.partenaire1.prenom`), on ne teste donc que son
// dernier segment.
const CHAMP_PRENOM = /prenom/i;

const isChampPrenom = (name?: string | null): boolean =>
  CHAMP_PRENOM.test(_.last(_.split(name ?? '', '.')) ?? '');

/**
 * Met en forme la saisie d'un champ de prénom, comme sur etcv : première
 * lettre en majuscule, le reste en minuscule, pour chaque partie d'un prénom
 * composé ("JEAN-PIERRE" -> "Jean-Pierre").
 *
 * À brancher sur les `onChange` de formulaire : `name` est le nom du champ
 * saisi, et la valeur est retournée telle quelle si ce n'est pas un champ de
 * prénom (ou si ce n'est pas une chaîne).
 *
 * La mise en forme est appliquée à la saisie, caractère par caractère : elle
 * préserve donc les séparateurs en cours de frappe (ex. "Jean-" reste
 * "Jean-").
 */
const formatPrenomSaisie = <T>(
  name: string | null | undefined,
  valeur: T,
): T | string => {
  if (!isChampPrenom(name) || !_.isString(valeur)) return valeur;

  return _.split(valeur, SEPARATEURS_PRENOM)
    .map((partie) =>
      SEPARATEURS_PRENOM.test(partie) ? partie : _.capitalize(partie),
    )
    .join('');
};

export default formatPrenomSaisie;
